module.exports = __webpack_public_path__ + "static/img/twitter.ce06c24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/twitter.png
// module id = ahy+
// module chunks = 0